import { find, propEq } from 'ramda';

import { api } from '@framework/constants/endpoints';
import { type Handler } from '@framework/server/middleware';
import { serverUrlBuilder } from '@framework/server/utils';

import { type ApiResponse, type ListApiResponse } from '@type/api';
import { type Member } from '@type/members';
import { type Room } from '@type/rooms';

export const fetchActiveRoom: Handler<[], Room | undefined> = async (
    ctx,
    { axiosServer, setState }
) => {
    const {
        data: { results: roomsData }
    } = await axiosServer.get<ListApiResponse<Room>>(serverUrlBuilder(api.rooms()));

    const activeRoom = find(propEq(ctx.query.room, 'slug'), roomsData);

    setState({
        loggedMember: {
            id: activeRoom?.memberUuid
        }
    });

    return activeRoom;
};

export const fetchActiveMember: Handler<[], Member | undefined> = async (
    _ctx,
    { axiosServer, getState, setState }
) => {
    const loggedMemberUuid = getState().loggedMember?.id;

    if (!loggedMemberUuid) {
        return undefined;
    }

    const {
        data: { results: memberData }
    } = await axiosServer.get<ApiResponse<Member>>(serverUrlBuilder(api.member(loggedMemberUuid)));

    setState({
        loggedMember: {
            data: memberData
        }
    });

    return memberData;
};
